import { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { getReadableTextColor, getSlightlyContrastingColor, defaultColorScheme } from '@helpers/color_scheme_helpers.js'
import TimetoastPropTypes from '../../../../constants/timetoast_prop_types'

export default class ColorSchemePreview extends Component {
  getMarker(identifier = '') {
    const { colorScheme } = this.props
    const className = classnames('color-scheme-preview__marker', `color-scheme-preview__marker--${identifier}`)
    const backgroundColor = colorScheme.secondary
    const style = { backgroundColor }
    const textStyle = { backgroundColor: getReadableTextColor(backgroundColor, colorScheme) }
    return (
      <div className={className} style={style} title="Collapsed event">
        <div className="text" style={textStyle} />
        <div className="text" style={textStyle} />
      </div>
    )
  }

  getMarkerPositionIndicator(identifier = '') {
    const { colorScheme } = this.props
    const className = classnames(
      'color-scheme-preview__marker-position-indicator',
      `color-scheme-preview__marker-position-indicator--${identifier}`
    )
    const color = colorScheme.highlight
    const lineStyle = { borderLeftColor: color }
    const dotStyle = { backgroundColor: color }
    return (
      <div className={className} title="Event position">
        <div className="line" style={lineStyle} />
        <div className="dot" style={dotStyle} />
      </div>
    )
  }

  getExpandedMarker() {
    const { colorScheme } = this.props
    const style = { backgroundColor: colorScheme.secondary }
    const textStyle = { backgroundColor: getReadableTextColor(colorScheme.secondary, colorScheme) }
    return (
      <div className="color-scheme-preview__expanded-marker" style={style} title="Expanded event/timespan">
        <div className="color-scheme-preview__expanded-marker-content">
          <div className="title-wrapper">
            <div className="text" style={textStyle} />
            <div className="text" style={textStyle} />
          </div>
          <div className="text" style={textStyle} />
          <div className="text" style={textStyle} />
          <div className="text" style={textStyle} />
          <div className="text" style={textStyle} />
          <div className="text" style={textStyle} />
          <div className="text" style={textStyle} />
        </div>
      </div>
    )
  }

  getTimespan() {
    const { colorScheme } = this.props
    const backgroundColor = colorScheme.highlight
    const style = { backgroundColor }
    const textStyle = { backgroundColor: getReadableTextColor(backgroundColor, colorScheme) }
    return (
      <div className="color-scheme-preview__timespan" style={style} title="Timespan">
        <div className="text" style={textStyle} />
      </div>
    )
  }

  getScale() {
    const { colorScheme } = this.props
    const style = { backgroundColor: colorScheme.tertiary }
    return (
      <div className="color-scheme-preview__scale" title="Time scale">
        <div>
          <div className="color-scheme-preview__tick" style={style} />
        </div>
        <div>
          <div className="color-scheme-preview__tick" style={style} />
        </div>
        <div>
          <div className="color-scheme-preview__tick" style={style} />
        </div>
        <div>
          <div className="color-scheme-preview__tick" style={style} />
        </div>
        <div>
          <div className="color-scheme-preview__tick" style={style} />
        </div>
      </div>
    )
  }

  getScrubber() {
    const { colorScheme } = this.props
    const surfaceStyle = { backgroundColor: getSlightlyContrastingColor(colorScheme.primary) }
    const viewportStyle = { backgroundColor: colorScheme.highlight }
    return (
      <div className="color-scheme-preview__scrubber" title="Scrubber">
        <div className="color-scheme-preview__surface" style={surfaceStyle} />
        <div className="color-scheme-preview__viewport" style={viewportStyle} />
      </div>
    )
  }

  render() {
    const { colorScheme } = this.props
    const style = { backgroundColor: colorScheme.primary }
    return (
      <div className="color-scheme-preview">
        <div className="content" style={style}>
          {this.getMarkerPositionIndicator('first')}
          {this.getMarker('first')}
          {this.getMarkerPositionIndicator('second')}
          {this.getMarker('second')}
          {this.getExpandedMarker()}
          {this.getTimespan()}
          {this.getScale()}
          {this.getScrubber()}
        </div>
      </div>
    )
  }
}
ColorSchemePreview.propTypes = {
  colorScheme: TimetoastPropTypes.colorScheme.isRequired,
}
ColorSchemePreview.defaultProps = {
  colorScheme: defaultColorScheme(),
}
